<!--
Author: TangChen
Date: 2018-09-17
Desc: 用户信息展示组件，由index.js 配置引入
-->
<template>
    <div class="bizcomp-acct-info">
        <comp-title :title="title" />
        <el-row class="accountInfo">
            <el-col :span="6" class="circle-bg">
                <div class="act-info clear">
                    <div class="act-img">
                        <img
                            v-if="info.headimage && (info.headimage || '').indexOf('http') === -1"
                            :src="$util.fileDownloadPath(info.headimage)"
                            alt=""
                        />
                        <img v-else :src="require('../../assets/img/account-img.png')" alt="" />

                        <el-upload
                            :action="$util.fileUploadPath('/sale-mid-ump/file/cmsUpload')"
                            :data="$util.fileUploadParam('10')"
                            :headers="$util.fileUploadHeader()"
                            :before-upload="uploadBefore"
                            :on-error="uploadError"
                            :on-success="uploadSuccess"
                            :show-file-list="false"
                        >
                            <span v-if="$util.getConfig().hideFunc" class="img-btn">编辑</span>
                        </el-upload>
                    </div>
                    <div class="act-basic">
                        <div class="user-info">
                            <p class="name">
                                <span
                                    class="k-text-flow"
                                    :class="{ mobilet: !info.custname }"
                                    :title="info.custname ? info.custname : info.mobileno"
                                >
                                    {{ info.custname }}
                                    <span
                                        v-if="!$util.getConfig().userinfoHide"
                                        class="like-a"
                                        v-on:click="$router.push({ name: 'modifyinfo' })"
                                    >
                                        <template v-if="$util.getConfig().hideFunc">
                                            [编辑个人信息]
                                        </template>
                                        <template v-else>[个人信息查看]</template>
                                    </span>
                                </span>
                            </p>
                        </div>
                        <div class="investor">
                            <p class="login-time investor-content">
                                投资者类型：
                                <span>
                                    {{
                                        (info.professionflag
                                            ? $cache.getDict("120051", info.professionflag)
                                            : "未知") +
                                        (info.professionflag === "1" &&
                                        info.professionexpired === "1"
                                            ? "(已过期)"
                                            : "")
                                    }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="18" class="user-info-icon">
                <el-col :span="8" class="risk-info">
                    <span class="icon-img" />
                    <div class="icon-info">
                        <span class="amount">风险类型</span>
                        <span class="amount-info">
                            {{
                                info.risklevel
                                    ? $cache.getDict("100017", info.risklevel)
                                    : "未做风险评测"
                            }}
                            <span
                                v-if="
                                    info.risklevel &&
                                    $util.getConfig().hideFunc &&
                                    $cache.getBinded()
                                "
                                class="like-a"
                                v-on:click="$router.push({ name: 'risk' })"
                            >
                                [重新测评]
                            </span>
                            <span
                                v-if="
                                    !info.risklevel &&
                                    $util.getConfig().hideFunc &&
                                    $cache.getBinded()
                                "
                                class="like-a"
                                v-on:click="$router.push({ name: 'risktest' })"
                            >
                                [立即评测]
                            </span>
                        </span>
                    </div>
                </el-col>
                <el-col :span="8" class="phone-info">
                    <span class="icon-img mobile" />
                    <div class="icon-info">
                        <span class="amount">手机</span>
                        <span class="amount-info">
                            {{
                                info.mobileno.length === 11
                                    ? $util.desensitizePhoneNumber(info.mobileno)
                                    : "没有绑定手机号"
                            }}
                            <span
                                v-if="
                                    $cache.getBinded() &&
                                    $util.getConfig().hideFunc &&
                                    !$util.belongHx()
                                "
                                class="like-a"
                                v-on:click="
                                    $router.push({
                                        name: $util.isEmpty(info.mobileno)
                                            ? 'bindmobile'
                                            : 'checkmobile'
                                    })
                                "
                            >
                                {{ "[" + (!$util.isEmpty(info.mobileno) ? "修改" : "绑定") + "]" }}
                            </span>
                            <span
                                v-if="$util.getConfig().hideFunc && $util.belongHx()"
                                class="like-a"
                                v-on:click="toHxEdit"
                            >
                                {{ "[" + (!$util.isEmpty(info.mobileno) ? "修改" : "绑定") + "]" }}
                            </span>
                        </span>
                    </div>
                </el-col>
                <el-col v-if="$util.getConfig().hideFunc" :span="8" class="pwd-info">
                    <span class="icon-img safe" />
                    <div class="icon-info">
                        <span class="amount">安全中心</span>
                        <span class="amount-info">
                            <span
                                v-if="info.mobileno.length === 11"
                                class="like-a"
                                v-on:click="toEditLPwd"
                            >
                                [登录密码]
                            </span>

                            <span
                                v-if="
                                    !$util.isEmpty(info.certificatetype) &&
                                    info.mobileno.length === 11 &&
                                    !$util.getConfig().hideFunc
                                "
                            >
                                /
                            </span>
                            <span
                                v-if="
                                    !$util.isEmpty(info.certificatetype) &&
                                    !$util.getConfig().hideFunc
                                "
                                class="like-a"
                                v-on:click="$router.push({ name: 'changetpwd' })"
                            >
                                [交易密码]
                            </span>
                        </span>
                    </div>
                </el-col>
            </el-col>
        </el-row>
        <bank-and-user-info></bank-and-user-info>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
import BankAndUserInfo from "@/bizcomponents/acctManager/bankAndUserInfo.vue";
export default {
    name: "AcctInfo",
    components: { BankAndUserInfo },
    mixins: [mixin],
    data() {
        return {
            headimage: "",
            uploadFlag: true,
            info: {}
        };
    },
    watch: {
        "$store.state.user.info": {
            handler(newValue, oldValue) {
                this.initData();
            },
            deep: true // 启用深度监听
        }
    },
    created() {
        this.initData();
    },
    methods: {
        initData() {
            this.info = this.$cache.getUser();
            this.info.headimage = this.$cache.getHeadImage();
            if (
                this.$cache.getBinded() &&
                this.$store.state.user.info &&
                this.$store.state.user.info.custname
            ) {
                this.$util.getProfession((data) => {
                    this.info = Object.assign({}, this.info, data);
                });
            }
        },
        async toEditLPwd() {
            if (this.$util.belongHx()) {
                const changePwd = this.$util.getConfig().hxUrl.changePwd;
                window.open(changePwd, "_blank");
            } else {
                this.$router.push({ name: "changelpwd" });
            }
        },
        async toHxEdit() {
            const changeMobile = this.$util.getConfig().hxUrl.changeMobile;
            window.open(changeMobile, "_blank");
        },
        uploadBefore(file) {
            let maxSize = "3";
            if (file.size > 1024 * 1024 * maxSize) {
                this.headimage = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return false;
            }
        },
        uploadError(err, file, fileList) {
            this.$message.warning(err);
        },
        async uploadSuccess(response, file, fileList) {
            const res = await userApi.modifyAcctExt({
                headimage: response.data.id
            });
            if (res.code == "0") {
                const info = this.$cache.getUser();
                info.headimage = response.data.id;
                this.$cache.setHeadImage(response.data.id);
                this.$store.dispatch("setInfo", info);
                this.info.headimage = response.data.id;
            }
        },
        upHeaderImg(file) {
            setTimeout(async () => {
                const res = await userApi.cmsUpload({ file: file });
            }, 200);
        },
        upImg() {
            this.$refs.upImg.click();
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/* 用户信息 */
.bizcomp-acct-info {
    margin-bottom: 20px;
    .accountInfo {
        width: 1200px;
        height: 128px;
        box-sizing: border-box;
        border: 1px solid #d9d9d9;
        z-index: 1;
        border-radius: 6px;
        margin-bottom: 20px;
        .act-info {
            height: 88px;
            padding: 20px 0;
            display: flex;
            align-items: center;
            .act-img {
                position: relative;
                margin-left: 16px;
                width: 50px;
                height: 50px;
                float: left;
                border-radius: 100% 100%;
                -webkit-border-radius: 100% 100%;
                overflow: hidden;
                img {
                    width: 50px;
                    height: 50px;
                }
                .img-btn {
                    position: absolute;
                    bottom: 0px;
                    line-height: 24px;
                    z-index: 100;
                    width: 100%;
                    left: 0;
                    cursor: pointer;
                    text-align: center;
                    color: $text-color6;
                    font-size: $f12;
                    background-color: rgba(0, 0, 0, 0.3);
                    display: none;
                }
                &:hover .img-btn {
                    display: block;
                }
                .el-input {
                    position: absolute;
                    bottom: 0px;
                    right: 0px;
                    z-index: 101;
                    opacity: 0;
                }
            }
            .act-basic {
                float: left;
                color: $text-color2;
                line-height: 24px;
                padding-left: 20px;
                p {
                    display: inline-block;
                    vertical-align: middle;
                }
                .investor {
                    line-height: 24px;
                    color: $text-color1;
                    span {
                        vertical-align: middle;
                        color: $text-color2;
                    }
                    .investor-content {
                        display: flex;
                        align-items: center;
                    }
                }
                .user-info {
                    line-height: 40px;
                    .name .k-text-flow {
                        font-size: $f20;
                        display: inline-block;
                        vertical-align: middle;
                        font-family: 思源黑体;
                        font-weight: bold;
                        .like-a {
                            font-size: $f14;
                            width: auto;
                            margin-left: 10px;
                            font-family: 思源黑体;
                            font-weight: normal;
                        }
                        &.mobilet {
                            font-size: $f18;
                        }
                    }
                }
            }
        }
        .user-info-icon {
            height: 128px;
            padding: 20px 0;
            .icon-img {
                width: 50px;
                height: 50px;
                border-radius: 100%;
                background: $bg1 url($investor) -209px 0px no-repeat;
                &.mobile {
                    background-position-x: -259px;
                }
                &.safe {
                    background-position-x: -305px;
                }
            }
            .icon-info,
            .icon-img {
                display: inline-block;
                vertical-align: middle;
            }
            .icon-info {
                margin-left: 16px;
                .amount {
                    display: block;
                    color: $text-color2;
                    line-height: 26px;
                    font-size: $f16;
                    font-family: 思源黑体;
                    color: #333333;
                    font-weight: 500;
                }
                .amount-info {
                    color: #666666;
                    line-height: 26px;
                    .like-a:first-of-type {
                        margin-left: 5px;
                    }
                }
            }
            .risk-info {
                display: flex;
                align-items: center;
                display: block;
                padding: 19px 0 19px 36px;
                border-left: 1px dashed #d9d9d9;
                border-right: 1px dashed #d9d9d9;
            }
            .phone-info {
                display: flex;
                align-items: center;
                display: block;
                padding: 19px 0 19px 32px;
                border-right: 1px dashed #d9d9d9;
            }
            .pwd-info {
                display: flex;
                align-items: center;
                display: block;
                padding: 19px 0 19px 32px;
            }
        }
    }
}
</style>
